import { Stack, Typography } from "@mui/material";
import { CustomButton } from "../../ui/CustomButton";
import { BaseModal } from "../../ui/BaseModal";
import React from "react";

export const DiscardModal = ({
  isOpen,
  successHandler,
  onCancelHandler,
}: {
  isOpen: boolean;
  successHandler: () => void;
  onCancelHandler: () => void;
}) => {
  return (
    <BaseModal
      open={isOpen}
      onClose={onCancelHandler}
      title="Discard Account"
      sx={{ padding: "32px", maxWidth: "368px", width: "90%" }}
    >
      <Stack gap="32px" maxWidth="304px" width="100%">
        <Typography component="span" variant="body1" color="text.secondary">
          Are you sure you want to clear data about “Company”?
        </Typography>
        <Stack direction="row" gap="8px">
          <CustomButton
            onClick={onCancelHandler}
            variant="contained"
            textColor="#4C545B"
            fullWidth
            type="button"
            customColor="#F1F1F1"
          >
            Cancel
          </CustomButton>
          <CustomButton
            onClick={successHandler}
            variant="contained"
            fullWidth
            type="button"
            customColor="#CF3E00"
          >
            Discard
          </CustomButton>
        </Stack>
      </Stack>
    </BaseModal>
  );
};
